import { APP_NAME } from 'constants/autoforms';
import { Title } from 'react-head';
import { useIntl } from 'react-intl';

export default function PageWrapper({ title = '', titleId = '', children }) {
    const intl = useIntl();
    return (
        <div>
            <Title>{titleId ? <>{`${intl.formatMessage({ id: titleId })} - ${APP_NAME}`}</> : title}</Title>
            {children}
        </div>
    );
}
